import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AccountVerification, IsAccountVerified } from '../../services/AuthService';
import Loader from '../../common/Loader';

const AccountVerificationCompleted: React.FC = () => {
  const [verificationStatus, setVerificationStatus] = useState<string | null>(null);
  const [tokenPass, setTokenPass] = useState<string | null>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [showVerifiedMessage, setShowVerifiedMessage] = useState<boolean>(false);
  const [hasCheckedVerification, setHasCheckedVerification] = useState<boolean>(false);



  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    const tokenValue = params.get('token');
    console.log("URL token:", tokenValue); // ✅ See what's in URL
    if (tokenValue) {
      setTokenPass(tokenValue);
    }
  }, []);
  

  useEffect(() => {
    if (tokenPass) {
      verification();
    }
  }, [tokenPass]);

  const verification = async () => {
    if (!tokenPass) return;
    const response = await IsAccountVerified(tokenPass);
    if (response.isSuccess) {
      setIsVerified(true);
      setShowVerifiedMessage(true);
    }
    setHasCheckedVerification(true); // Mark that we’ve checked
  };
  

  const handleYes = async () => {
    setLoading(true);
    if (tokenPass) {
      try {
        const response = await AccountVerification(tokenPass);
        if (response.isSuccess) {
          setVerificationStatus('Account Verified Successfully');
          setIsButtonDisabled(true);
  
          setTimeout(() => {
            setVerificationStatus(null); 
            setShowVerifiedMessage(true);
          }, 4000); 
        } else {
          setVerificationStatus('Verification Failed');
        }
      } catch (error) {
        console.error('Error verifying account:', error);
        setVerificationStatus('Verification Failed');
      } finally {
        setLoading(false);
      }
    } else {
      setVerificationStatus('Token not found');
    }
  };
  

  return (
    <Container
      className='mt-5'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Loader isLoading={loading} />
      <Row className='justify-content-center'>
        <Col sm={8} className='text-center'>
          <div>
            <img src='/large-logo.png' alt='Logo' className='w-50 my-4' />
          </div>

          <div>
            <img src='/email-verify.png' alt='Logo' className='w-50' />
          </div>

          <p className='btn-text offcanvas-title'>Verify Your Email Address</p>

          <p className='my-4'>
            In order to start using your Acu Trans Application, you need to confirm your email address
          </p>

          <div className='d-flex justify-content-center mt-3'>
            <Button
              variant='primary'
              id='VerifyButton'
              className='ms-3 d-flex align-items-center'
              onClick={handleYes}
              disabled={isButtonDisabled || !isVerified}
            >
              <span className='material-symbols-outlined me-2 verification-icon'>verified</span>
              Verify Email Address
            </Button>
          </div>

          {/* Show success message for 2 seconds after verification */}
          {verificationStatus && (
            <div className='mt-4'>
              <h5>{verificationStatus}</h5>
            </div>
          )}

          {/* Show "Account has been already verified." if verified */}
        {/* Show "Account has been already verified." only after verification check */}
{hasCheckedVerification && !isVerified && (
  <p className='mt-2'>Account has been already verified.</p>
)}

        </Col>
      </Row>
    </Container>
  );
};

export default AccountVerificationCompleted;
